// Library
import React, { useState } from "react";
import { Typography } from "antd";
import classNames from "classnames";
import { BemHelper } from "../../utils/BemHelper";

// Image
import playIcon from "./images/play.svg";

const { Title } = Typography;
const bem = new BemHelper("tutorial-box");

type Props = {
  title: string;
  link: string;
  video: string;
  image: any;
};

export const TutorialBox: React.FC<Props> = ({ title, link, video, image }) => {
  const [showVideo, setShowVideo] = useState(false);
  return (
    <div className={classNames(bem.block())}>
      <div className={classNames(bem.element("wrapper"))}>
        <a href={link} rel='noreferrer' target='_blank'>
          <Title level={5}>{title}</Title>
        </a>
        <div className={classNames(bem.element("video"))}>
          {showVideo ? (
            <iframe
              src={video + "?autoplay=1"}
              frameBorder='0'
              allow='autoplay'
              allowFullScreen
              style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
            />
          ) : (
            <div
              className={classNames(bem.element("preview"))}
              style={{
                background: `url('${image}') no-repeat`,
              }}
              onClick={() => setShowVideo(true)}
            >
              <img width='50px' src={playIcon} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
